import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Spinner from 'components/Spinner/Spinner';

export default class AppRouteLoading extends Component {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        pastDelay: PropTypes.bool.isRequired,
        retry: PropTypes.func.isRequired,
        error: PropTypes.object,

        // This feature is disabled by default
        // timedOut: PropTypes.bool.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.isLoading !== this.props.isLoading
            // || nextProps.timedOut !== this.props.timedOut
            || nextProps.pastDelay !== this.props.pastDelay
            || nextProps.error !== this.props.error) {
            return true;
        }

        return false;
    }

    render() {
        // || this.props.timedOut
        if (this.props.error) {
            return (
                <main className='page-wrap'>
                    <p className='text-center'>
                        Désolé, une erreur est apparue.
                    </p>

                    <p className='text-center'>
                        <button onClick={this.props.retry}>
                            Cliquez ici pour réessayer de charger la page.
                        </button>
                    </p>
                </main>
            );
        }

        if (this.props.pastDelay) {
            return (
                <main className='page-wrap'>
                    <div className='loading-container'>
                        <Spinner />
                    </div>
                </main>
            );
        }

        return null;
    }
}
